var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentssmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.93 10.13a.8.8 0 0 1 .54.04c.86.39 1.45.54 2.5.54 2.85 0 5.09-2.17 5.09-4.77 0-2.6-2.24-4.77-5.08-4.77-2.87 0-5.09 2-5.09 4.77 0 1.04.37 1.69.75 2.35l.02.04c.1.2.13.42.07.64l-.52 1.62 1.72-.46Zm.2.77c.97.43 1.66.61 2.85.61 3.24 0 5.88-2.49 5.88-5.57S9.22.37 5.98.37C2.73.37.09 2.67.09 5.94.1 7.2.55 8 .93 8.66l.03.06-.74 2.32c-.1.3.18.6.49.51l2.43-.65Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentssmall);
export default __webpack_public_path__ + "static/media/comments.small.a71110872f8452e6b262afea07ff4416.svg";
export { ForwardRef as ReactComponent };